<template>
  <div class="drop-i">
    <input
      v-if="category.children.length"
      type="checkbox"
      :id="`check-menu-${category.id}`"
      class="input-menu"
    />

    <router-link
      class="cat-item"
      :to="{
        name: 'Products',
        query: { page: 1, category: category.id },
      }"
    >
      <span @click="handleQuery()">{{ category.name }}</span>
    </router-link>
    <b-icon
      icon="caret-down-fill"
      class="mr-2 dropdown-icon"
      variant="secondary"
      v-if="category.children.length"
    />

    <div
      v-if="category.children.length"
      class="sub-item"
      :id="'category-' + category.id"
    >
      <router-link
        class="cat-item p-2 pb-5 underline"
        :to="{
          name: 'Products',
          query: { page: 1, category: category.id },
        }"
      >
        <span @click="handleQuery()">همه موراد {{ category.name }}</span>
      </router-link>
      <category
        v-for="children in category.children"
        :key="children.id"
        :category="children"
        :margin="margin + 7"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Category",
  props: ["category", "categoryId", "margin"],
  data() {
    return {
      mobile: false,
    };
  },
  computed: {},
  methods: {
    handleQuery() {
      this.$store.commit("Product/setFilters", {
        key: "category",
        value: this.$route.query.category,
      });
    },
  },
};
</script>

<style scoped>
.underline {
  text-decoration: underline;
}
.borderless {
  border: none;
}

.cat-item {
  color: #a9a6a6;
  font-size: 15px;
  width: 100%;
}

.collapsed {
  color: black;
}
.not-collapsed {
  color: deeppink;
}
.not-collapsed + .cat-item {
  font-weight: bold;
}
.drop-i {
  padding: 5px;
  position: relative;
  transition: all 0.2s ease-in;
  cursor: pointer;
}
.sub-item {
  padding: 10px 2px;
}
.drop-i .sub-item {
  display: none;
  transition: display 0.5s ease-in;
}
.dropdown-icon {
  position: absolute;
  left: 15px;
  top: 20px;
  transform: translateY(-50%) rotate(90deg);
  transition: transform 0.3s ease-in-out;
}
.input-menu {
  opacity: 0;
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 42px;
  cursor: pointer;
  z-index: 9999;
}
.input-menu:checked ~ .dropdown-icon {
  transform: translateY(-50%) rotate(0deg);
}

.input-menu:checked ~ .sub-item {
  display: block;
  position: absolute;
  right: 99%;
  top: 0;

  background: white;
  min-width: 250px;
  width: auto;
  border: 1px #ccc solid;
  z-index: 1000;
  border-radius: 4px;
}
@media only screen and (max-width: 980px) {
  .input-menu:checked ~ .sub-item {
    display: block;
    position: relative;
    top: unset;
    right: unset;
    background: white;
    min-width: 250px;
    width: auto;
    border: 1px #ccc solid;
    z-index: 1000;
    border-radius: 4px;
  }
}
</style>